import { SortCountry } from '../interface/sort-country';
import { FirstChar } from './first-char';
import { After, Before } from './util';
import { Multicountry } from '../../../../../../shared/interfaces/create-surveys.interface';
import { Name } from './name';

export class Alphabethical implements SortCountry {
  constructor(public readonly countryList: Multicountry[]) {}

  sort(): Multicountry[] {
    return [
      ...this.countryList.sort((a, b) => {
        if (this.verifyFirst(a, b)) {
          return new Before().values();
        }

        return new After().values();
      }),
    ];
  }

  verifyFirst(a: Multicountry, b: Multicountry) {
    return (
      new FirstChar(new Name(a).value())
        .value()
        .localeCompare(new FirstChar(new Name(b).value()).value()) <= 0
    );
  }
}
